import React, { useRef } from 'react';
import { compose, pure, withState } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import Typography from '@material-ui/core/Typography';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    border: 0,
    marginBottom: -1,
    padding: '0 10px',
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0
  }
})(MuiAccordionDetails);

// const PopoverStyle = {
//   top: '-50px'
// };

const styles = {
  textBody: {
    fontWeight: 'normal',
    fontSize: 14,
    borderBottom: '1px solid #CCCCCC',
    backgroundColor: '#ffffff'
  },
  breakLine: {
    whiteSpace: 'break-spaces'
  },
  leftIcon: {
    padding: '0px 5px'
  },
  button: {
    padding: '1px',
    pointerEvents: 'none'
  },
  iconHelpEx: {
    color: 'gray !important'
  },
  popover: {
    pointerEvents: 'none',
    minWidth: 400
  },
  popoverContent: {
    pointerEvents: 'auto'
  },
  wrapper: {
    padding: 20,
    minWidth: 400
  },
  amountDiv: {
    display: 'flex',
    paddingTop: 5
  },
  smallAmountNumber: {
    fontSize: 30,
    fontWeight: 'bold',
    color: '#000'
  },
  currencyUnitSmall: {
    fontWeight: 'bold',
    fontSize: 15,
    padding: '15px 0 10px 5px',
    color: '#000'
  },
  horizotalLine: {
    borderBottom: '1px solid #DBDBDB'
  },
  textHeading: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '16px',
    marginLeft: 5,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  collapseBtn: {
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    padding: 0,
    marginLeft: '-12px',
    borderBottom: 'none'
  },
  arrowCustom: {
    backgroundColor: '#2196F3',
    color: '#ffffff',
    width: 13,
    height: 13,
    borderRadius: '50%',
    margin: 0
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoRow: {
    border: '1px solid #ddd'
  },
  tableInfoCellHeader: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '12px',
    padding: '2px 10px',
    // width: '180px',
    // maxWidth: '150px',
    border: '1px solid #ddd',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '12px',
    padding: '2px 10px',
    // borderBottom: '2px solid transparent',
    border: '1px solid #ddd',
    whiteSpace: 'break-spaces'
  },
  textCenter: {
    textAlign: 'center'
  },
  btnSendMail: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 10
  },
  fs10: {
    fontSize: '10px !important'
  },
  smallAlert: {
    fontSize: 12,
    maxWidth: 200,
    whiteSpace: 'pre-line'
  },
  smallWrapper: {
    minWidth: 200,
    maxWidth: 200
  }
};

const enhance = compose(
  pure,
  withState('state', 'setState', {
    open: false,
    anchorEl: null
  })
);

const ShopTableBody = enhance(
  ({
    classes,
    shops, // emptyRows,
    currentMonthYear,
    page,
    rowsPerPage,
    order,
    orderBy,
    currencyFormat,
    state,
    setState,
    handleSendMailByShop,
    fromTopPageGroup,
    isFukuoka,
    isTable2
  }) => {
    const popoverAnchor = useRef(null);
    let sortedResult;
    if (orderBy === 'shopName') {
      sortedResult = _.orderBy(shops, ['shopId', 'shopName'], [order, order]);
    } else {
      sortedResult = _.orderBy(shops, orderBy, order);
    }

    let titleAlertShopDepositAmount =
      '入金明細は当月の10営業日以内に表示されます。しばらくお待ちください。';
    if (isFukuoka) {
      titleAlertShopDepositAmount =
        '毎月9営業日までは前月末の振込金額を表示します。10営業日からは今月末の振込予定金額を表示します。';
      if (isTable2) {
        titleAlertShopDepositAmount = '検索月の精算明細を表示します。';
      }
    }

    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            const key = `${shop.shopId}`;
            // const onClickParams = {
            //   shopId: shop.shopId,
            //   shopName: shop.shopName,
            //   otherGroupBankAccount:
            //     shop.groupId === null && shop.groupDepositManage === 'NONSELF',
            //   stripeUseSwitchable: shop.stripeUseSwitchable
            // };
            const handlePopoverOpen = (event, popoverId) => {
              setState({
                openedPopoverId: popoverId,
                anchorEl: event.target
              });
            };

            const handlePopoverClose = () => {
              setState({
                openedPopoverId: null,
                anchorEl: null
              });
            };

            const { anchorEl, openedPopoverId } = state;
            const smallWrapperClass =
              shop.shopDetailDeposit &&
              shop.shopDetailDeposit.shopDepositAmount !== null
                ? ''
                : classes.smallWrapper;

            return (
              <TableRow key={key}>
                <TableCell className={classes.textBody}>
                  {shop.shopId}
                </TableCell>
                <TableCell
                  className={`${classes.textBody} ${classes.breakLine}`}
                >
                  {shop.shopName}
                </TableCell>
                {!isFukuoka && (
                  <TableCell className={classes.textBody}>
                    {shop.gochiBuyAmount || shop.gochiBuyAmount === 0
                      ? currencyFormat(shop.gochiBuyAmount)
                      : '-'}
                  </TableCell>
                )}
                <TableCell className={classes.textBody}>
                  {shop.gochiUsedAmount || shop.gochiUsedAmount === 0
                    ? currencyFormat(shop.gochiUsedAmount)
                    : '-'}
                </TableCell>
                <TableCell className={classes.textBody}>
                  {shop.depositAmountCurrentMonth ||
                  shop.depositAmountCurrentMonth === 0
                    ? currencyFormat(shop.depositAmountCurrentMonth)
                    : '-'}
                </TableCell>
                {!isTable2 && (
                  <TableCell className={classes.textBody}>
                    {shop.depositAmountNextMonth ||
                    shop.depositAmountNextMonth === 0
                      ? currencyFormat(shop.depositAmountNextMonth)
                      : '-'}
                  </TableCell>
                )}
                {!fromTopPageGroup && (
                  <TableCell className={classes.textBody}>
                    <Button
                      key={shop.shopId}
                      ref={popoverAnchor}
                      style={{ backgroundColor: 'transparent' }}
                      onMouseEnter={e => handlePopoverOpen(e, shop.shopId)}
                      onMouseLeave={handlePopoverClose}
                    >
                      <HelpIcon className={classes.iconHelpEx} />
                    </Button>
                    <Popover
                      elevation={1}
                      id="mouse-over-popover"
                      className={`${classes.popover}`}
                      classes={{
                        paper: classes.popoverContent
                      }}
                      open={openedPopoverId === shop.shopId}
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left'
                      }}
                      onClose={handlePopoverClose}
                      disableRestoreFocus
                      PaperProps={{
                        onMouseEnter: e => handlePopoverOpen(e, shop.shopId),
                        onMouseLeave: handlePopoverClose
                      }}
                    >
                      <div
                        className={`${classes.wrapper} ${smallWrapperClass}`}
                      >
                        <div className={classes.amountDiv}>
                          {shop.shopDetailDeposit &&
                          shop.shopDetailDeposit.shopDepositAmount !== null ? (
                            <>
                              <div className={classes.smallAmountNumber}>
                                {currencyFormat(
                                  shop.shopDetailDeposit.shopDepositAmount
                                )}
                              </div>
                              <div className={classes.currencyUnitSmall}>
                                円*
                              </div>
                            </>
                          ) : (
                            <div className={classes.smallAlert}>
                              {titleAlertShopDepositAmount}
                            </div>
                          )}
                        </div>
                        {shop.shopDetailDeposit &&
                          shop.shopDetailDeposit.shopDepositAmount !== null && (
                            <div className={classes.horizotalLine} />
                          )}
                        {shop.shopDetailDeposit &&
                          shop.shopDetailDeposit.shopDepositAmount !== null && (
                            <Accordion defaultExpanded>
                              <AccordionSummary
                                expandIcon={
                                  <ExpandMoreIcon
                                    className={classes.arrowCustom}
                                  />
                                }
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                                className={classes.collapseBtn}
                              >
                                <Typography className={classes.textHeading}>
                                  {isFukuoka ? '精算明細' : '銀行口座入金分'}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails className={classes.scrollX}>
                                <Table className={classes.tableInfo}>
                                  <TableBody>
                                    {shop.shopDetailDeposit &&
                                      shop.shopDetailDeposit
                                        .shopPaymentSummaries &&
                                      shop.shopDetailDeposit
                                        .shopPaymentSummaries.length > 0 &&
                                      shop.shopDetailDeposit.shopPaymentSummaries.map(
                                        item => {
                                          return (
                                            <TableRow
                                              className={classes.tableInfoRow}
                                            >
                                              <TableCell
                                                className={
                                                  classes.tableInfoCellHeader
                                                }
                                              >
                                                {item.rowLabel}
                                              </TableCell>
                                              <TableCell
                                                className={
                                                  classes.tableInfoCell
                                                }
                                              >
                                                {currencyFormat(item.amount)}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        }
                                      )}
                                  </TableBody>
                                </Table>
                              </AccordionDetails>
                              {shop.shopDetailDeposit &&
                                shop.shopDetailDeposit.shopPaymentSummaries &&
                                shop.shopDetailDeposit.shopPaymentSummaries
                                  .length > 0 && (
                                  <div className={classes.textCenter}>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      className={classes.btnSendMail}
                                      onClick={() => {
                                        handleSendMailByShop(
                                          currentMonthYear,
                                          shop.shopId
                                        );
                                      }}
                                    >
                                      {isFukuoka
                                        ? '精算明細を送る'
                                        : '入金明細を送る'}
                                    </Button>
                                    <Typography
                                      color="textPrimary"
                                      className={classes.fs10}
                                    >
                                      {isFukuoka
                                        ? '※登録メールアドレス宛に送ります'
                                        : '※入金明細を登録メールアドレス宛に送ります'}
                                    </Typography>
                                  </div>
                                )}
                            </Accordion>
                          )}
                      </div>
                    </Popover>
                  </TableCell>
                )}

                {/* <TableCell>{shop.phone}</TableCell> */}
              </TableRow>
            );
          })}
        {/* {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )} */}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
